import React from 'react';
import * as Styled from './questionDetailsStyled';

import Outline from '../../images/outline.svg';
import Wave1 from '../../images/wave_1.svg';
import Wave2 from '../../images/wave_2.svg';
import parse from 'html-react-parser'

function questionTypeLabel(code) {
  if (code === 'MCQ') return 'Multiple Choice Questions';
  if (code === 'ORDERING') return 'Ordering Questions';
  return 'Compiler Question';
}

function questionDetail(value) {
  if (!value) return '';
  const text = String(value)
    .replace(/[\s\u00a0]+$/g, '')
    .replace(/(?:<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>)+$/gi, '');
  return /<[a-z][\s\S]*>/i.test(text) ? parse(text) : text;
}

function orderingStepText(value) {
  return String(value || '');
}

function orderingSteps(question) {
  let data = question.question_data;
  if (!data) return [];
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      return [];
    }
  }
  const options = Array.isArray(data.options) ? data.options : [];
  const byId = {};
  options.forEach((opt) => {
    if (opt && opt.id != null) byId[String(opt.id)] = opt;
  });
  const order = Array.isArray(data.correct_answer) ? data.correct_answer : [];
  return order.map((id) => byId[String(id)]).filter(Boolean);
}

const Modal = props => {
  let question = {};
  if (props.question && props.question.data && props.question.data[0]) {
    question = props.question.data[0];
  }
  return (
    <Styled.ModalMainDiv>
      <Styled.ModalDiv style={{ transform: props.show ? 'translateX(-50%)' : 'translate(-50%, -100vh)', opacity: props.show ? 1 : 0 }}>
        { props.loading === true ?
          <Styled.LoadingDiv>
            <Styled.LoaderWrapDiv>
              <Styled.OutlineImg src={Outline} />
              <Styled.AnimationDiv>
                <Styled.WaveImg src={Wave1} zindex="3" duration="1s" />
                <Styled.WaveImg src={Wave2} zindex="1" duration="2s" />
                <Styled.BubbleDiv style={{ left: '10%', backgroundColor: '#fc8ac1' }} duration="1s" />
                <Styled.BubbleDiv style={{ left: '30%', backgroundColor: '#f0b7d2' }} duration="2s" />
                <Styled.BubbleDiv style={{ left: '60%', backgroundColor: '#e9589e' }} duration="3s" />
              </Styled.AnimationDiv>
            </Styled.LoaderWrapDiv>
            <Styled.HeadingDiv>Please Wait ...</Styled.HeadingDiv>
            <Styled.SubHeadingDiv>Getting details</Styled.SubHeadingDiv>
          </Styled.LoadingDiv>
        :
          <Styled.DetailsWrapDiv>
            <Styled.HeadingDiv style={{ padding: '0px 0px 20px 0px' }}>{props.heading}</Styled.HeadingDiv>

            <Styled.QuestionWrapDiv>
              <Styled.InputWrap>
                <Styled.TitleDiv>Question Title</Styled.TitleDiv>
                <Styled.ValueDiv>{question.question_title}</Styled.ValueDiv>
              </Styled.InputWrap>

              <Styled.InputWrap>
                <Styled.TitleDiv>Skills</Styled.TitleDiv>
                <Styled.ValueDiv>{question.category_name}</Styled.ValueDiv>
              </Styled.InputWrap>

              <Styled.InputWrap>
                <Styled.TitleDiv>Topics</Styled.TitleDiv>
                <Styled.ValueDiv>{question.topic_name}</Styled.ValueDiv>
              </Styled.InputWrap>

              <Styled.InputWrap>
                <Styled.TitleDiv>Difficulty Level</Styled.TitleDiv>
                <Styled.ValueDiv>{question.difficulty_level}</Styled.ValueDiv>
              </Styled.InputWrap>

              <Styled.InputWrap>
                <Styled.TitleDiv>Question Type</Styled.TitleDiv>
                <Styled.ValueDiv>{questionTypeLabel(question.question_type_code)}</Styled.ValueDiv>
              </Styled.InputWrap>

              <Styled.InputWrap>
                <Styled.TitleDiv>Question Details</Styled.TitleDiv>
                <Styled.ValueDiv>{questionDetail(question.question_detail)}</Styled.ValueDiv>
              </Styled.InputWrap>

              { question.question_type_code === 'MCQ' ?
                <Styled.GreyBoxDiv>
                  <Styled.OptionRowDiv style={{ marginBottom: '4px' }}>
                    <Styled.TitleDiv style={{ minWidth: '72px' }}>Correct</Styled.TitleDiv>
                    <Styled.TitleDiv>Question Options</Styled.TitleDiv>
                  </Styled.OptionRowDiv>
                  { question.question_data && question.question_data.options ?
                    question.question_data.options.map((opt, optIndex) => {
                      let is_correct = false;
                      if (question.question_data.correct_answer && question.question_data.correct_answer.includes(opt.index)) {
                        is_correct = true;
                      }
                      return (
                        <Styled.OptionRowDiv style={{ marginBottom: '10px' }}>
                          <Styled.CheckboxDiv active={is_correct}>{optIndex + 1}</Styled.CheckboxDiv>
                          <Styled.ValueDiv>{opt?.option?parse(opt?.option):''}</Styled.ValueDiv>
                        </Styled.OptionRowDiv>
                      );
                    })
                  : ''
                  }
                </Styled.GreyBoxDiv>
              : ''
              }

              { question.question_type_code === 'ORDERING' ?
                <Styled.GreyBoxDiv>
                  <Styled.OptionRowDiv style={{ marginBottom: '4px' }}>
                    <Styled.TitleDiv style={{ minWidth: '72px' }}>Order</Styled.TitleDiv>
                    <Styled.TitleDiv>Correct Order</Styled.TitleDiv>
                  </Styled.OptionRowDiv>
                  { orderingSteps(question).map((step, stepIndex) => (
                    <Styled.OptionRowDiv key={step.id || stepIndex} style={{ marginBottom: '10px', alignItems: 'flex-start' }}>
                      <Styled.OrderIndex>{stepIndex + 1}</Styled.OrderIndex>
                      <Styled.ValueDiv>{orderingStepText(step.option)}</Styled.ValueDiv>
                    </Styled.OptionRowDiv>
                  )) }
                </Styled.GreyBoxDiv>
              : ''
              }

              { question.question_type_code === 'COMPILER' ?
                <Styled.GreyBoxDiv>
                  <Styled.OptionRowDiv style={{ marginBottom: '4px' }}>
                    <Styled.TitleDiv style={{ minWidth: '178px' }}>Input</Styled.TitleDiv>
                    <Styled.TitleDiv>Output</Styled.TitleDiv>
                  </Styled.OptionRowDiv>

                  { question.question_data.map((opt, optIndex) => (
                    <Styled.OptionRowDiv style={{ marginBottom: '16px' }}>
                      <Styled.ValueDiv style={{ marginRight: '12px', width: '50%' }}>{opt.std_input}</Styled.ValueDiv>
                      <Styled.ValueDiv style={{ width: '50%' }}>{opt.std_output}</Styled.ValueDiv>
                      <Styled.CheckboxDiv2 active={opt.visibility === 'PUBLIC'}>Public</Styled.CheckboxDiv2>
                      <Styled.CheckboxDiv2 active={opt.visibility === 'PRIVATE'}>Private</Styled.CheckboxDiv2>
                    </Styled.OptionRowDiv>
                  )) }
                </Styled.GreyBoxDiv>
              : ''
              }
            </Styled.QuestionWrapDiv>

            <Styled.SaveWrapDiv>
              <Styled.CancelButton onClick={e => props.close(e)}>Cancel</Styled.CancelButton>
            </Styled.SaveWrapDiv>
          </Styled.DetailsWrapDiv>
        }
        
      </Styled.ModalDiv>
      <Styled.ModalWrapDiv onClick={e => props.close(e)} style={{ display: props.show ? 'block' : 'none' }} />
    </Styled.ModalMainDiv>
  )
}

export default Modal
